/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = SalesPaymentOrder
 *
 * 2 = FullPaymentOrDirectDebit
 *
 * 3 = ManualEntry
 */
export enum ServicePlanPaymentType {
  SalesPaymentOrder = 1,
  FullPaymentOrDirectDebit = 2,
  ManualEntry = 3,
}
